import { useState } from "react";
import {
  FaMapMarkerAlt,
  FaLocationArrow,
  FaCheckCircle,
  FaPhoneAlt,
} from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import { taxis } from "../data/content";
import { PHONE_TEL, PHONE_DISPLAY } from "../data/config";

export default function Booking() {
  const [done, setDone] = useState(false);

  return (
    <>
      <PageHeader title="Book a Ride" crumbs={[{ label: "Booking" }]} />
      <section className="section">
        <div className="container two-col">
          <div>
            <span className="subtitle">Quick Booking</span>
            <h2 style={{ fontSize: 34, margin: "8px 0 16px" }}>
              Reserve Your Ride in Minutes
            </h2>
            <p className="sec-text" style={{ marginBottom: 24 }}>
              Fill in your trip details and our system will match you with the
              nearest available driver. Fast, safe and reliable — 24/7.
            </p>
            <ul className="check-list" style={{ marginBottom: 28 }}>
              <li><FaCheckCircle /> Instant driver matching</li>
              <li><FaCheckCircle /> Transparent, upfront pricing</li>
              <li><FaCheckCircle /> Real-time ride tracking</li>
              <li><FaCheckCircle /> Free cancellation within the grace window</li>
            </ul>
            <a href={PHONE_TEL} className="card" style={{ padding: 24, display: "flex", gap: 14, alignItems: "center" }}>
              <span className="fstrip-icon"><FaPhoneAlt /></span>
              <div>
                <p style={{ color: "var(--gray-light)", fontSize: 13 }}>Need help booking?</p>
                <h4 style={{ fontSize: 20 }}>{PHONE_DISPLAY}</h4>
              </div>
            </a>
          </div>

          <div className="booking-widget">
            {done ? (
              <div style={{ textAlign: "center", padding: "30px 0" }}>
                <div className="confirm-icon"><FaCheckCircle /></div>
                <h3>Booking Confirmed!</h3>
                <p className="sec-text mt-2">
                  Thank you! We've received your request and a driver will be
                  assigned shortly. A confirmation will be sent to you.
                </p>
                <button className="btn btn-primary mt-3" onClick={() => setDone(false)}>
                  Book Another Ride
                </button>
              </div>
            ) : (
              <>
                <h3>Book Your Ride</h3>
                <form onSubmit={(e) => { e.preventDefault(); setDone(true); }}>
                  <div className="field">
                    <label><FaMapMarkerAlt /> Pickup Location</label>
                    <input type="text" placeholder="Enter pickup location" required />
                  </div>
                  <div className="field">
                    <label><FaLocationArrow /> Drop-off Location</label>
                    <input type="text" placeholder="Enter destination" required />
                  </div>
                  <div className="form-row">
                    <div className="field">
                      <label>Date</label>
                      <input type="date" required />
                    </div>
                    <div className="field">
                      <label>Time</label>
                      <input type="time" required />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="field">
                      <label>Ride Type</label>
                      <select>
                        {taxis.map((t) => <option key={t.id}>{t.title}</option>)}
                      </select>
                    </div>
                    <div className="field">
                      <label>Passengers</label>
                      <select>
                        {[1, 2, 3, 4, 5, 6].map((n) => <option key={n}>{n}</option>)}
                      </select>
                    </div>
                  </div>
                  <div className="field">
                    <label>Full Name</label>
                    <input type="text" placeholder="Your name" required />
                  </div>
                  <div className="field">
                    <label>Phone Number</label>
                    <input type="tel" placeholder="Your phone number" required />
                  </div>
                  <button type="submit" className="btn btn-primary btn-block">
                    Confirm Booking
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
